import { Outlet } from 'react-router-dom';
import AuthProgressBar from '../components/AuthProgressBar/AuthProgressBar';

const LoginLayout = () => {
  return (
    <div>
      <AuthProgressBar />
      <Outlet /> 
    </div>
  );
};

export default LoginLayout;
